module.exports = __webpack_public_path__ + "static/financing-55a320828cc6a25f0611593aac6424ee.jpg";